export enum QueueStatus {
  New = 1,
  InProgress = 2,
  Complete = 3,
  Error = 4
}
